import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';
import { Button, Input, Modal, Space, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

export const CloseModal = ({ sinistre, visible, onCancel, onConfirm, loading, setLoading, isClosed }) => {
    const [motif, setMotif] = useState('');
    const [action, setAction] = useState('');

    const navigate = useNavigate();

    const handleSolder = () => {
        console.log("Solder");
        let sort = "";
        if (action === "sanssuite") sort = "S";
        if (action === "reouvrir") sort = "R";
        if (action === "solder") sort = "T";
        setLoading(true);
        axiosInstance
            .get(`/api/sinistre/${sort === "R" ? "reouvrir" : "cloture"}/${sinistre.codeId}/${sort}`)
            .then((res) => {
                onCancel();
                setLoading(false);
                toast.success(sort === "S" ? "Dossier classé sans suite avec succès!" : sort === "R" ? "Dossier reouvert avec succès!" : "Dossier clôturé (terminé) avec succès!");
                navigate(`/details-sinistre`, {
                    state: { codeId: res.data.codeId },
                });
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
                toast.error(sort === "S" ? "Échec lors de la classation du dossier sans suite!" : sort === "R" ? "Échec lors de la reouverture du dossier!" : "Échec lors de la clôture du dossier!");
                onCancel();
            });
    };

    return (
        <Modal
            title={
                <Space>
                    <ExclamationCircleOutlined style={{ color: '#faad14' }} />
                    {isClosed ? 'Réouverture du dossier' : 'Clôture du dossier'}
                </Space>
            }
            open={visible}
            onCancel={onCancel}
            confirmLoading={loading}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Annuler
                </Button>,
                !isClosed && !motif && (
                    <Button
                        key="sanssuite"
                        onClick={() => setAction('sanssuite')}
                        type="primary"
                        style={{ background: '#1890ff' }}
                    >
                        Classer Sans Suite
                    </Button>
                ),
                !isClosed && !motif && <Button
                    key="primary"
                    onClick={() => setAction(isClosed ? 'reouvrir' : 'solder')}
                    type="primary"
                    danger={!isClosed}
                >
                    {isClosed ? 'Réouvrir' : 'Solder'}
                </Button>,
                isClosed && !motif && <Button
                    key="primary"
                    onClick={() => setAction('reouvrir')}
                    type="primary"
                    danger={!isClosed}
                    style={{ backgroundColor: "green" }}
                >
                    {isClosed ? 'Réouvrir' : 'Solder'}
                </Button>,
                motif.length > 2 && (
                    <Button
                        key="primary"
                        onClick={() => handleSolder()}
                        type="primary"
                        style={{ backgroundColor: "#212466" }}
                    >
                        Valider
                    </Button>
                )
            ]}
        >
            {action === 'sanssuite' || action === 'solder' || action === 'reouvrir' ? (
                <div>
                    <Typography.Paragraph>
                        Veuillez confirmer la {!isClosed ? 'clôture' : 'réouverture'} du dossier en précisant le motif
                    </Typography.Paragraph>
                    <Input.TextArea
                        placeholder={`Motif de ${!isClosed ? 'clôture' : 'réouverture'}...`}
                        rows={4}
                        value={motif}
                        onChange={(e) => setMotif(e.target.value)}
                    />
                </div>
            ) : (
                <Typography.Paragraph>
                    Veuillez confirmer la clôture du dossier en précisant la catégorie de sinistre
                </Typography.Paragraph>
            )}
        </Modal>
    );
};

CloseModal.propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    loading: PropTypes.bool,
    setLoading: PropTypes.func,
    isClosed: PropTypes.bool,
    sinistre: PropTypes.object,
};